<template>
  <div>
    <menuBar></menuBar>
    <v-card width="670" class="mx-auto mt-10">
      <v-card-title class="py-0"></v-card-title>

      <v-card-text class="pa-0">
        <!-- <v-card width="100%" class="pa-0 ma-0">
          <v-card-text>
            <h2 class="text-center">{{this.$AppName.CoLtdMenuBarFull}}</h2>
          </v-card-text>
        </v-card>-->
        <v-row justify="space-between">
          <v-col cols="auto">
            <v-img
              height="80%"
              width="280"
              src="@/assets/newchok-icon.png"
              v-if="this.$AppName.name == 'นิวโชคอำนวยเชียงใหม่'"
            ></v-img>
              <v-img
              height="80%"
              width="280"
              src="@/assets/municipalitylogo.png"
               v-if="this.$AppName.name == 'เทศบาลนครเชียงใหม่'"
            ></v-img>
          </v-col>

          <v-col cols="auto" class="text-center pa-5 ma-7">
            <h4 class="mb-5">กรอกข้อมูลเพื่อเข้าสู่ระบบ</h4>
            <v-form>
              <v-text-field
                label="Username"
                v-model="username"
                prepend-icon="mdi-account-circle"
              />
              <v-text-field
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                v-model="password"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
              />
              <v-btn width="100%" class="mt-3" color="success" @click="login()"
                >เข้าสู่ระบบ</v-btn
              >
              <!-- <v-btn width="100%" class="mt-3" color="success">Register</v-btn> -->
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>

    <!-- <v-footer
      absolute
      outlined
      light
      padless
      color="white"
      class="font-weight-medium"
    >
      <v-col class="text-right" cols="12">
        Copyright © LAPA SYSTEMS 2020
      </v-col>
    </v-footer>-->
  </div>
</template>

<script>
import menuBar from "../components/menuBar";
export default {
  name: "SignIn",
  components: {
    menuBar,
  },
  data() {
    return {
      username: "",
      password: "",
      showPassword: false,
    };
  },
  methods: {
    login() {
      let v = this;
      const options = {
        data: {
          username: v.username,
          password: v.password,
        },
      };
      this.$guest_api
        .post("/login", options.data)
        .then((response) => {
          if (response.data.success == 1) {
            //console.log(response.data.token)

            localStorage.setItem("jwt", response.data.token);
            this.$token_api.defaults.headers["Authorization"] =
              response.data.token;
            //console.log(localStorage.getItem("jwt"))
            localStorage.setItem("user", JSON.stringify(response.data.user));
            window.location.href = `${this.$global_link}/newCustomer/all-newCustomer`;

            // v.$router.push({path: "/dashboard/all-report"});
          } else {
            v.$swal(
              "ผู้ใช้งาน หรือ รหัสผ่านไม่ถูกต้อง",
              "เกิดข้อผิดพลาด",
              "error"
            );
            v.username = "";
            v.password = "";
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
